import React from 'react';
interface SectionHeadingProps {
  folio?: string;
  title: string;
  align?: 'left' | 'center';
  as?: 'h2' | 'h3';
  id?: string;
  tone?: 'gold' | 'paper';
  children?: React.ReactNode;
}
export function SectionHeading({
  folio,
  title,
  align = 'center',
  as: Tag = 'h2',
  id,
  tone = 'gold',
  children
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return <div className={`flex flex-col ${alignment}`} data-id="element-165" data-mp="bl59skjzf44u">
      {folio ? <span className="mb-5 font-folio text-[0.62rem] uppercase tracking-[0.34em] text-gold/80" data-id="element-166" data-mp="giexnvrq37qk">
          {folio}
        </span> : null}
      <Tag id={id} className={`font-display text-[1.7rem] font-light uppercase leading-tight tracking-[0.07em] sm:text-4xl lg:text-[2.5rem] ${tone === 'gold' ? 'text-gold' : 'text-paper'}`} data-id="element-167" data-mp="1sps7oclkhkh">
        {title}
      </Tag>
      <span aria-hidden="true" className="mt-6 block h-px w-28 bg-gold/45" data-id="element-168" data-mp="zapvhb7isfht" />
      {children ? <div className="mt-7 w-full" data-id="element-169" data-mp="1tah5pjxn0956">{children}</div> : null}
    </div>;
}